import React from 'react';

import { Flexer } from '@ontruck/orc';

import ShipperOrderTag from 'modules/shipper-order/Tag';

import { StyledItem } from 'modules/log/LogItem/styled';

import ActionName from 'modules/log/LogItem/modes/common/ActionName';
import Changes from 'modules/log/LogItem/modes/common/Changes';

import Reason from './components/Reason';
import Author from './components/Author';

import Icon from './components/Icon';
import Comment from './components/Comment';
import CommentEdit from './components/CommentEdit';

const ReadMode = (props) => {
  const {
    log_type,
    comment,
    action,
    reason,
    created_by,
    created_at,
    user_type,
    status,
    shipperOrdersSkin = {},
    shipper_order_id,
    onCommentClick,
    id,
    UIIsEditing = false,
    UIIsCreating = false,
    changes,
  } = props;

  const multipleShipperOrders = Object.keys(shipperOrdersSkin || {}).length > 1;

  const light = UIIsEditing || UIIsCreating;

  return (
    <StyledItem onDoubleClick={onCommentClick} light={light}>
      <Flexer.Parent alignItems="center" mBottom="XS">
        <Icon log_type={log_type} status={status} mRight="XS" />
        <Flexer.Child flex="1">
          <ActionName action={action} status={status} bold color="grey900" />
          <Reason action={action} reason={reason} color="grey700" />
        </Flexer.Child>
        {multipleShipperOrders && shipper_order_id && (
          <Flexer.Child mLeft="XS">
            <ShipperOrderTag
              id={shipper_order_id}
              shipperOrdersSkin={shipperOrdersSkin}
              withinGroupage
            />
          </Flexer.Child>
        )}
      </Flexer.Parent>
      <Changes action={action} changes={changes} mBottom="XS" shipperOrderId={shipper_order_id} />
      <Comment comment={comment} color="grey700" inline={false} mBottom="XS" />
      <Flexer.Parent alignItems="center">
        <Author
          userType={user_type}
          created_by={created_by}
          created_at={created_at}
          color="grey500"
          inline={false}
          flex="1"
        />
        {!!id && <CommentEdit className="showOnHover" comment={comment} onClick={onCommentClick} />}
      </Flexer.Parent>
    </StyledItem>
  );
};

export default ReadMode;
